export default __webpack_public_path__ + "983a3b33df4453045b2d5c5ec37694bc.png";